import {IHouseBooster} from "../../types/booster_generic/IHouseBooster";
import {IBoosterBigDataType} from "../../types/IBoosterBigDataType";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";

export const houseBDIncreasedInterestBooster: IHouseBooster = {
    category: IBoosterCategory.BigDataStats,
    type: IBoosterBigDataType.HasIncreasedInterest,

    isValid(params) {
        return !!params.property.boosters_bigdata_stats?.has_increased_interest;
    },

    getSegments() {
        return [
            "Duże zainteresowanie!",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: "Ten dom może niedługo zniknąć z oferty"
            }
        ];
    }
};
import {IHouseBooster} from "../../types/booster_generic/IHouseBooster";
import {IBoosterBigDataType} from "../../types/IBoosterBigDataType";
import {IBoosterCategory} from "../../types/IBoosterCategory";
import {IBoosterTextSegmentType} from "../../types/IBoosterTextSegmentType";

export const houseBDIncreasedInterestBooster: IHouseBooster = {
    category: IBoosterCategory.BigDataStats,
    type: IBoosterBigDataType.HasIncreasedInterest,

    isValid(params) {
        return !!params.property.boosters_bigdata_stats?.has_increased_interest;
    },

    getSegments() {
        return [
            "Duże zainteresowanie!",
            {
                type: IBoosterTextSegmentType.HIGHLIGHTED,
                text: "Ten dom może niedługo zniknąć z oferty"
            }
        ];
    }
};
